import React, { useState } from "react";

import HeadingSecondary from "../components/ HeadingSecondary";
import BottomArrow from "../components/svg/BottomArrow";
import DotLoading from "../components/DotLoading";
import Headphone from "../components/svg/Headphone";
import { BottomSheet } from "react-spring-bottom-sheet";
import { Link } from "react-router-dom";

const SettingSupport: React.FC<any> = () => {
  const [collapsed, setCollapsed] = useState(true);
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const [showBottomSheet, setShowBottomSheet] = useState(false);
  const selectCategory = () => {
    setShowBottomSheet(true);
  };
  return (
    <>
      <BottomSheet
        open={showBottomSheet}
        onDismiss={() => setShowBottomSheet(false)}
      >
        <div className="select-support-category">
          <h6 className="select-support-category__title u-margin-bottom-small-2">
            لطفا از بین دسته بندی های ذیل، انتخاب بفرمایید .
          </h6>
          <div className="select-radio">
            <div className="select-radio__group">
              <input
                type="radio"
                className="select-radio__input"
                id="health"
                name="category"
              />
              <label htmlFor="health" className="select-radio__label">
                <span className="select-radio__button" />
                بهداشت
              </label>
            </div>
            <div className="line2 u-margin-bottom-small-1 u-margin-top-small-1" />
            <div className="select-radio__group">
              <input
                type="radio"
                className="select-radio__input"
                id="tech"
                name="category"
              />
              <label htmlFor="tech" className="select-radio__label">
                <span className="select-radio__button" />
                فنی
              </label>
            </div>
            <div className="line2 u-margin-bottom-small-1 u-margin-top-small-1" />
            <div className="select-radio__group">
              <input
                type="radio"
                className="select-radio__input"
                id="pub"
                name="category"
              />
              <label htmlFor="pub" className="select-radio__label">
                <span className="select-radio__button" />
                عمومی
              </label>
            </div>
          </div>
        </div>
      </BottomSheet>
      <div className="setting">
        <div className="u-margin-top-small-2-5">
          <HeadingSecondary text="پشتیبانی" fontSize="3.1" />
        </div>

        <div className="setting__support u-margin-bottom-big">
          <div className="setting__support__head">
            <h5>بخش پشتیبانی</h5>
            <div className="setting__support__head__filter">
              <div className="guild__inquiry__filter">
                <div
                  className="guild__inquiry__filter__logo u-width-70"
                  style={{ left: 0 }}
                  onClick={() => {
                    setCollapsed(!collapsed);
                  }}
                >
                  {/* <Filter /> */}
                  <span>مرتب سازی</span>
                  <BottomArrow collapsed={collapsed} />
                </div>

                <div className="guild__inquiry__filter__content-holder">
                  <div
                    className="guild__inquiry__filter__content-holder__content"
                    style={{
                      left: 0,
                      top: "18px",
                      height: `${!collapsed ? "132px" : "0"}`,
                      opacity: `${!collapsed ? "1" : "0"}`,
                    }}
                  >
                    <h6>مرتب سازی بر اساس</h6>
                    <div className="line2"></div>
                    <ul>
                      <li>
                        <input
                          type="radio"
                          name="order"
                          value="DESC"
                          id="new"
                          onChange={(e) => {
                            setCollapsed(!collapsed);
                          }}
                        />
                        <label htmlFor="new">جدیدترین</label>
                      </li>
                      <div className="line2"></div>
                      <li>
                        <input
                          type="radio"
                          name="order"
                          value="ASC"
                          id="old"
                          onChange={(e) => {
                            setCollapsed(!collapsed);
                          }}
                        />
                        <label htmlFor="old">قدیمی ترین</label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="setting__support__body  u-margin-top-small-3">
            <Link to="/support/chat">
              <div className="support-box-info pending">
                <div className="support-box-info__right">
                  <h6 className="support-box-info__right__title">
                    عدم امکان دسترسی به بخش سوالات متدوال و پروفایل
                  </h6>
                  <div className="support-box-info__right__status">
                    <span>وضعیت پشتیبانی :</span>
                    <span>در حال انجام</span>
                  </div>
                </div>

                <div className="support-box-info__left">
                  <h6 className="support-box-info__left__date">1399/12/11</h6>
                  <div className="support-box-info__left__badge u-margin-r-auto">
                    <span>2</span>
                  </div>
                </div>
              </div>
            </Link>
            <div className="line3 u-margin-bottom-small-1 u-margin-top-small-1"></div>
            <div className="support-box-info">
              <div className="support-box-info__right">
                <h6 className="support-box-info__right__title">
                  عدم امکان دسترسی به بخش سوالات متدوال و پروفایل
                </h6>
                <div className="support-box-info__right__status">
                  <span>وضعیت پشتیبانی :</span>
                  <span>به پایین رسید</span>
                </div>
              </div>

              <div className="support-box-info__left">
                <h6 className="support-box-info__left__date">1399/12/11</h6>
              </div>
            </div>
            <div className="line3 u-margin-bottom-small-1 u-margin-top-small-1"></div>
            <div className="support-box-info">
              <div className="support-box-info__right">
                <h6 className="support-box-info__right__title">
                  عدم امکان دسترسی به بخش سوالات متدوال و پروفایل
                </h6>
                <div className="support-box-info__right__status">
                  <span>وضعیت پشتیبانی :</span>
                  <span>به پایین رسید</span>
                </div>
              </div>

              <div className="support-box-info__left">
                <h6 className="support-box-info__left__date">1399/12/11</h6>
              </div>
            </div>
            <div className="line3 u-margin-bottom-small-1 u-margin-top-small-1"></div>
            <div className="support-box-info">
              <div className="support-box-info__right">
                <h6 className="support-box-info__right__title">
                  عدم امکان دسترسی به بخش سوالات متدوال و پروفایل
                </h6>
                <div className="support-box-info__right__status">
                  <span>وضعیت پشتیبانی :</span>
                  <span>به پایین رسید</span>
                </div>
              </div>

              <div className="support-box-info__left">
                <h6 className="support-box-info__left__date">1399/12/11</h6>
              </div>
            </div>
            <div className="line3 u-margin-bottom-small-1 u-margin-top-small-1"></div>
            <button
              className="btn btn--primary u-width-100 u-margin-top-medium-5 u-margin-bottom-big"
              type={`${isLoading ? "button" : "submit"}`}
              onClick={selectCategory}
            >
              {!isLoading ? (
                <div className="u-d-flex u-align-item-center u-justify-content-center ">
                  <span className="u-d-flex u-align-item-center u-justify-content-center u-padding-left-small-1">
                    <Headphone />
                  </span>
                  <span>درخواست جدید</span>
                </div>
              ) : (
                <DotLoading />
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingSupport;
